import * as ol from 'openlayers'
import BaseAspect from './BaseAspect.js'

export default class BaseLineAspect extends BaseAspect {

	constructor(data){
		let transformedCordinates = [];
		let coordinates = data.coordinates.trim().split(' ');
		coordinates.forEach(function(point) {
			let latLonPair = point.split(',');
			let pos = ol.proj.transform([parseFloat(latLonPair[1]), parseFloat(latLonPair[0])], 'EPSG:4326', 'EPSG:3857');
			transformedCordinates.push(pos);
		});

		super(data);
        this.set('zIndex', 2);
    	if(data.hasOwnProperty('type')) {
			this.set('type', data.type);
		} else {
			this.set('type', 'BaseLineAspect');
		}
		this.set('geometry', new ol.geom.MultiLineString([transformedCordinates]));

		this.set('state', data.state);
	}

	createStyle() {
		// if(this.get('geometry'))


        let iconImage = new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: '#F00',
                width: 8,
                lineCap: "square"
            })
        });
        return [iconImage];
	}
}
